import { useEffect, useState } from 'react';
import { fetchPublicImages } from '../utils/api.js';

export function useGalleryImages() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let ignore = false;

    async function loadImages() {
      try {
        const nextImages = await fetchPublicImages();
        if (!ignore) {
          setImages(nextImages);
          setError('');
        }
      } catch (loadError) {
        if (!ignore) setError(loadError.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    loadImages();
    return () => {
      ignore = true;
    };
  }, []);

  return { images, loading, error };
}
